import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';

export class EstateClearVaultExportService extends ExportTypeBaseService {
  /**
   * @var {Estate}
   */
  estate;

  /**
   * @return {string}
   */
  getFilename() {
    this.estate = getters.export.getData().estate;
    return `${this.estate.contact.fullName.replaceAll(' ', '-')}-clearvault-summary.pdf`;
  }

  /**
   * @return {*}
   */
  getSnackBarTitle() {
    this.estate = getters.export.getData().estate;
    return Lang.t("estate.plan-summary-exporting", {
      name: this.estate.contact.fullName
    });
  }
}

export default new EstateClearVaultExportService();
